import styled from 'styled-components';

import { rem, size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const GalleryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: ${size(-1.5)};
  position: relative;

  > * {
    flex: 0 0 25%;
    padding: ${size(1.5)};
  }
`;

export const Image = styled.img`
  display: block;
  width: 100%;
`;

export const ImageButton = styled.button`
  &:after {
    content: '';
    opacity: 0;
    transition: opacity 100ms linear;
    background: rgba(0, 0, 0, 0.2);
    position: absolute;
    top: ${size(1.5)};
    left: ${size(1.5)};
    right: ${size(1.5)};
    bottom: ${size(1.5)};
  }

  &:hover:after {
    opacity: 1;
  }
`;

export const ShowAllButton = styled(ImageButton)`
  position: absolute;
  z-index: 1;
  top: ${size(1.5)};
  right: ${size(1.5)};
  bottom: ${size(1.5)};
  width: calc(25% - ${size(3)});
  color: ${theme.colors.text.onAlt};
  font-size: ${rem(20)};
  font-weight: 600;
  padding: 0;

  &:before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${size(8)};
    height: ${size(8)};
    background: ${theme.colors.bg.alt};
    border-radius: 50%;
  }

  &:after {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  ${theme.screens.Lg} {
    font-size: ${rem(24)};

    &:before {
      width: ${size(9)};
      height: ${size(9)};
    }
  }
`;
